import { withSidekickTransportTimeout } from './sidekickHttp';

// Separate knob from HTTP request timeout; keep the current 60s budget
// until the BE heartbeat SLA gives us a tighter per-read ceiling.
export const SIDEKICK_SSE_READ_TIMEOUT_MS = 60_000;

/** Reads one SSE body chunk with a bounded silence timeout. */
export const readSseChunk = async ({
  reader,
  signal,
  timeoutMessage,
}: {
  reader: ReadableStreamDefaultReader<Uint8Array>;
  signal: AbortSignal;
  timeoutMessage: string;
}): Promise<ReadableStreamReadResult<Uint8Array>> => {
  if (signal.aborted) {
    await reader.cancel().catch(() => undefined);
    return { done: true, value: undefined };
  }

  const cancelReader = () => {
    void reader.cancel().catch(() => undefined);
  };
  signal.addEventListener('abort', cancelReader, { once: true });
  if (signal.aborted) {
    cancelReader();
  }

  try {
    return await withSidekickTransportTimeout({
      operation: reader.read(),
      message: timeoutMessage,
      onTimeout: cancelReader,
      timeoutMs: SIDEKICK_SSE_READ_TIMEOUT_MS,
    });
  } finally {
    signal.removeEventListener('abort', cancelReader);
  }
};
